import React from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { PopupEntryPoint } from '../shared/popup-entry-point';

import { PREMIUM_DIALOG_CONFIG, STANDARD_DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './paymentDetailsPopup.entrypoint';

export function PaymentDetailsPopup(): React.JSX.Element {
	const { edition } = useEditionAwareness();

	return (
		<PopupEntryPoint
			entryPoint={entryPoint}
			placement={'bottom-end'}
			dialogConfig={edition === 'standard' ? STANDARD_DIALOG_CONFIG : PREMIUM_DIALOG_CONFIG}
		/>
	);
}
